var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1492_92602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.601673 11.8564C0.601115 13.8728 1.128 15.8418 2.12986 17.5772L0.505859 23.5067L6.57395 21.9156C8.25231 22.8293 10.1328 23.3081 12.0437 23.3082H12.0487C18.3571 23.3082 23.4923 18.1749 23.495 11.8654C23.4962 8.80798 22.3066 5.93301 20.1453 3.77003C17.9844 1.60724 15.1104 0.415519 12.0483 0.414124C5.73916 0.414124 0.604371 5.54715 0.601766 11.8564",
    fill: "url(#paint0_linear_1492_92602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.193285 11.8527C0.192634 13.9417 0.738401 15.981 1.77598 17.7786L0.09375 23.9207L6.37942 22.2726C8.11133 23.2168 10.0613 23.7147 12.0455 23.7154H12.0506C18.5853 23.7154 23.9049 18.3975 23.9077 11.8621C23.9088 8.69488 22.6764 5.71656 20.4379 3.47609C18.1991 1.23591 15.2224 0.00130233 12.0506 0C5.51477 0 0.19589 5.31721 0.193285 11.8527ZM3.93654 17.469L3.70184 17.0965C2.71524 15.5277 2.19449 13.7149 2.19524 11.8534C2.19738 6.4213 6.61822 2.00186 12.0543 2.00186C14.6869 2.00298 17.1609 3.02921 19.0218 4.89116C20.8825 6.7533 21.9064 9.22865 21.9058 11.8614C21.9033 17.2935 17.4824 21.7135 12.0506 21.7135H12.0467C10.278 21.7126 8.54342 21.2376 7.03068 20.34L6.67068 20.1265L2.94063 21.1045L3.93654 17.4689V17.469Z",
    fill: "url(#paint1_linear_1492_92602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08679 6.89746C8.86483 6.40416 8.63125 6.39421 8.42018 6.38556C8.24734 6.37811 8.04976 6.37867 7.85237 6.37867C7.65479 6.37867 7.33376 6.453 7.06241 6.74928C6.79079 7.04583 6.02539 7.76249 6.02539 9.22007C6.02539 10.6777 7.08707 12.0864 7.23507 12.2843C7.38325 12.4817 9.28465 15.5686 12.296 16.7562C14.7987 17.743 15.308 17.5468 15.8512 17.4973C16.3944 17.448 17.6041 16.7808 17.8509 16.089C18.0979 15.3973 18.0979 14.8043 18.0238 14.6804C17.9498 14.557 17.7522 14.4829 17.4559 14.3348C17.1595 14.1866 15.703 13.4698 15.4314 13.371C15.1598 13.2722 14.9623 13.2229 14.7647 13.5195C14.5672 13.8157 13.9998 14.4829 13.8269 14.6804C13.6541 14.8785 13.4812 14.9031 13.185 14.755C12.8886 14.6063 11.9344 14.2938 10.8024 13.2846C9.92167 12.4993 9.32707 11.5296 9.15423 11.2329C8.98139 10.9367 9.13572 10.7762 9.28427 10.6285C9.41739 10.4958 9.58065 10.2826 9.72893 10.1096C9.87665 9.93663 9.92595 9.81318 10.0247 9.6156C10.1236 9.41783 10.0741 9.24481 10.0002 9.09663C9.92595 8.94844 9.35023 7.48323 9.08679 6.89746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1492_92602",
    x1: 1149.96,
    y1: 2309.67,
    x2: 1149.96,
    y2: 0.414124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1492_92602",
    x1: 1190.79,
    y1: 2392.07,
    x2: 1190.79,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1492_92602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.814,
    height: 24,
    fill: "white",
    transform: "translate(0.09375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.783c3d6b02b26f7cf07effd752305517.svg";
export { ForwardRef as ReactComponent };